import { GoogleLogin } from '@react-oauth/google';
import '../css/estilo.css'
import { useLogin } from "../hooks/useLogin"
import CardContenedor from '../components/CardContenedor';

export const Login = () => {

    // localStorage.removeItem('user_empleado')
    const { onLoginFailure, onLoginSuccess, mostrarBtnLogin, traerPermisosTxt } = useLogin()

    return (
        <CardContenedor>
            {/* autenticación google */}

            <p className="lead text-center">
                Inicia sesión con tu cuenta de correo institucional para continuar.
                <br />
                Ejemplo: <b>usuario@utescuinapa.edu.mx</b>
            </p>
            <div className="d-inline text-center">
                {traerPermisosTxt()}
            </div>

            <div className="d-inline text-center d-flex justify-content-center">
                {mostrarBtnLogin && (
                    <GoogleLogin
                        onSuccess={onLoginSuccess}
                        onError={onLoginFailure}
                    />
                )}
            </div>
        </CardContenedor>
    )
}
